import { render, staticRenderFns } from "./DashboardLoader.vue?vue&type=template&id=31662136&scoped=true"
import script from "./DashboardLoader.vue?vue&type=script&lang=js"
export * from "./DashboardLoader.vue?vue&type=script&lang=js"
import style0 from "./DashboardLoader.vue?vue&type=style&index=0&id=31662136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31662136",
  null
  
)

export default component.exports